import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../model/reducer';
import { inventoryKeyView } from '../../model/views';
import { first } from 'rxjs/operators';
import { PublishInventoryDialogService } from './publish-inventory-dialog.service';
import { PublishInventoryDialogComponent } from './publish-inventory-dialog.component';
import { ClearPublishInventoryData } from '../../model/publish-inventory/publish-inventory.actions';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PublishInventoryMainComponent implements OnInit, OnDestroy {
  private publishInventoryDialogService = inject(PublishInventoryDialogService);
  private store$ = inject<Store<AppState>>(Store);

  dialogRef: MatDialogRef<PublishInventoryDialogComponent>;

  ngOnInit(): void {
    // setTimeout is workaround for view creation inside change detection cycle
    setTimeout(() => {
      this.store$.pipe(select(inventoryKeyView), first()).subscribe((inventoryKey: string) => {
        this.dialogRef = this.publishInventoryDialogService.openPublishChangesWindow(inventoryKey);
      });
    });
  }

  ngOnDestroy(): void {
    if (this.dialogRef) {
      this.dialogRef.afterClosed().subscribe(() => {
        this.store$.dispatch(new ClearPublishInventoryData());
      });
      this.dialogRef.close();
    }
  }
}
